

function ConferenceStatute() {

    return (
        <>
            <div>
                <p><span class="statuteParagraphHeader">§1. Postanowienia ogólne</span></p>
                <ol>
                    <li>
                        Niniejszy Regulamin określa zasady organizacji i uczestnictwa w Konferencji "Przełknijmy to razem!" (dalej: „Konferencja").
                    </li>
                    <li>
                        Organizatorem Konferencji jest Polskie Stowarzyszenie Rodzin z Atrezją Przełyku z siedzibą we Wrocławiu, ul. Piękna 60AB/17, 50-506 NIP: 8993002964, REGON: 529570950 (dalej: „Organizator").
                    </li>
                    <li>
                        Konferencja "Przełknijmy to razem!", zwana w dalszej części Regulaminu Konferencją, odbywa się w terminie i miejscu wskazanym przez Organizatora.
                    </li>
                    <li>
                        Konferencja została zorganizowana z myślą o rodzicach/opiekunach dzieci żyjących z atrezją przełyku oraz dorosłych dotkniętych tą wadą wrodzoną.
                    </li>
                    <li>
                        W ramach Konferencji będą odbywały się sesje naukowo-dydaktyczne, edukacyjne i warsztatowe.
                    </li>
                    <li>
                        Organizator zastrzega sobie prawo do zmiany terminu i miejsca Konferencji w uzasadnionym przypadku.
                    </li>
                    <li>
                        Przepisy niniejszego Regulaminu stanowią integralną część zgłoszenia uczestnictwa w Konferencji i obowiązują wszystkich Uczestników.
                    </li>
                    <li>
                        Oficjalny serwis internetowy Konferencji znajduje się pod adresem: <a href="www.konferencja.przelyczki.org.pl" target="_blank">www.konferencja.przelyczki.org.pl</a>
                    </li>
                    <li>
                        Określone niniejszym Regulaminem prawa i obowiązki Uczestnika oraz Organizatora obowiązują wyłącznie do końca dnia, w którym odbędzie się Konferencja tj. do 09.05.2026r.
                    </li>
                </ol>
            </div>
            <div>
                <p><span class="statuteParagraphHeader">§2. Zasady uczestnictwa w Konferencji i wydarzeniu towarzyszącym</span></p>
                <ol>
                    <li>
                        Warunkiem udziału w Konferencji jest:
                        <ol>
                            <li>
                                prawidłowe wypełnienie formularza rejestracyjnego dostępnego na stronie internetowej (<a href="www.konferencja.przelyczki.org.pl" target="_blank">www.konferencja.przelyczki.org.pl</a>) lub przesłanie zgłoszenia w wiadomości e-mail na adres: <a href="mailto:kontakt@przelyczki.org.pl">kontakt@przelyczki.org.pl</a> oraz uiszczenie opłaty do dnia <b>30.04.2026r.</b> Po tym terminie formularz rejestracyjny będzie niedostępny, a rejestracja będzie możliwa tylko przez kontakt z Organizatorem.
                            </li>
                            <li>
                                wniesienie opłaty konferencyjnej zgodnie z zamieszczonym na stronie cennikiem oraz akceptacja niniejszego Regulaminu. Dane do płatności podane będą w wiadomości e-mail z potwierdzeniem rejestracji.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Warunkiem udziału w wydarzeniu towarzyszącym (wspólnej kolacji po Konferencji) jest:
                        <ol>
                            <li>
                                prawidłowe wypełnienie formularza rejestracyjnego dostępnego na stronie internetowej (<a href="www.konferencja.przelyczki.org.pl" target="_blank">www.konferencja.przelyczki.org.pl</a>) lub przesłanie zgłoszenia w wiadomości e-mail na adres: <a href="mailto:kontakt@przelyczki.org.pl">kontakt@przelyczki.org.pl</a> oraz uiszczenie opłaty do dnia <b>14.04.2026r.</b> Po tym terminie nie będzie możliwości zgłoszenia się na wydarzenie towarzyszące.
                            </li>
                            <li>
                                wniesienie opłaty za wydarzenie towarzyszące zgodnie z zamieszczonym na stronie cennikiem oraz akceptacja niniejszego Regulaminu. Dane do płatności podane będą w wiadomości e-mail z potwierdzeniem rejestracji.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Obowiązuje jeden formularz rejestracyjny na Konferencję i wydarzenie towarzyszące.
                    </li>
                    <li>
                        Zgłoszenie swojego uczestnictwa w Konferencji jest jednoznaczne z akceptacją niniejszego Regulaminu.
                    </li>
                    <li>
                        Zgłoszenie swojego uczestnictwa w wydarzeniu towarzyszącym (wspólnej kolacji po Konferencji) jest jednoznaczne z akceptacją niniejszego Regulaminu.
                    </li>
                    <li>
                        Rejestracja odbywa się drogą elektroniczną za pośrednictwem strony internetowej lub przesłania chęci udziału w Konferencji na adres: <a href="mailto:kontakt@przelyczki.org.pl">kontakt@przelyczki.org.pl</a>.
                    </li>
                    <li>
                        Organizator potwierdzi rejestrację drogą mailową na adres e-mail wskazany przez Uczestnika.
                    </li>
                    <li>
                        Organizator zastrzega sobie prawo do weryfikacji danych podanych w formularzu rejestracyjnym.
                    </li>
                    <li>
                        Liczba miejsc na Konferencji oraz wydarzeniu towarzyszącym jest ograniczona. O udziale decyduje kolejność zgłoszeń.
                    </li>
                    <li>
                        Zgodnie z  Ustawą z 10 maja 2018 roku o Ochronie Danych Osobowych (RODO), Organizator nie przekazuje, nie sprzedaje i nie użycza zgromadzonych danych osobowych Uczestników innym osobom lub instytucjom. Dane osobowe podane przez Uczestnika (imię i nazwisko, adres e-mailowy) traktowane są jako informacje poufne i służą tylko i wyłącznie do celów komunikacji pomiędzy Uczestnikiem, a Organizatorem Konferencji.
                    </li>
                </ol>
            </div>
            <div>
                <p><span class="statuteParagraphHeader">§3. Opłaty</span></p>
                <ol>
                    <li>
                        Udział w Konferencji i wydarzeniu towarzyszącym jest odpłatny - zgodnie z informacją podaną na Stronie internetowej.
                    </li>
                    <li>
                        Warunkiem udziału jest dokonanie opłaty w wysokości i terminie wskazanym przez Organizatora.
                    </li>
                    <li>
                        Płatności za udział w Konferencji i wydarzeniu towarzyszącym należy dokonać przelewem na numer konta Organizatora, podany w wiadomości e-mail z potwierdzeniem rejestracji.
                    </li>
                    <li>
                        <strong>Opłata za udział w Konferencji jest bezzwrotna.</strong>
                    </li>
                    <li>
                        Opłata za udział w wydarzeniu towarzyszącym:
                        <ol>
                            <li>Zostanie zwrócona w całości w przypadku rezygnacji z wydarzenia towarzyszącego do dnia <b>14.04.2026r.</b></li>
                            <li>Nie podlega zwrotowi w przypadku rezygnacji z wydarzenia towarzyszącego po dniu <b>14.04.2026r.</b>, ze względu na konieczność wcześniejszego opłacenia rezerwacji w restauracji przez Organizatora.</li>
                        </ol>
                    </li>
                    <li>
                        Wystawienie faktury jest możliwe tylko przed dokonaniem płatności, po uprzednim kontakcie z Organizatorem i podaniem niezbędnych do wystawienia faktury danych. <b>Faktura wystawiona będzie tylko dla opłaty za udział w Konferencji</b>.
                    </li>
                    <li>
                        Brak terminowej płatności może skutkować anulowaniem rejestracji.
                    </li>
                </ol>
            </div>
            <div>
                <p><span class="statuteParagraphHeader">§4. Prawa i obowiązki Uczestników</span></p>
                <ol>
                    <li>
                        Uczestnik zobowiązany jest do przestrzegania postanowień niniejszego Regulaminu oraz zasad porządkowych obowiązujących w miejscu Konferencji.
                    </li>
                    <li>
                        Zabronione jest podejmowanie działań zakłócających przebieg Konferencji.
                    </li>
                    <li>
                        Uczestnik ponosi odpowiedzialność za szkody wyrządzone z jego winy lub z winy osób będących pod jego opieką.
                    </li>
                    <li>
                        Organizator zastrzega sobie prawo do usunięcia Uczestnika z Konferencji w przypadku rażącego naruszenia Regulaminu.
                    </li>
                </ol>
            </div>
            <div>
                <p><span class="statuteParagraphHeader">§5. Program Konferencji</span></p>
                <ol>
                    <li>
                        Organizator zastrzega sobie prawo do zmian w programie Konferencji, w tym zmiany prelegentów, harmonogramu lub formy wydarzenia.
                    </li>
                    <li>
                        Zmiany te nie stanowią podstawy do zgłaszania roszczeń wobec Organizatora.
                    </li>
                </ol>
            </div>
            <div>
                <p><span class="statuteParagraphHeader">§6. Wizerunek i materiały</span></p>
                <ol>
                    <li>
                        Konferencja może być rejestrowana w formie zdjęć oraz nagrań wideo.
                    </li>
                    <li>
                        Uczestnictwo w Konferencji oznacza zgodę na nieodpłatne utrwalanie i rozpowszechnianie wizerunku Uczestnika w celach informacyjnych i promocyjnych Organizatora.
                    </li>
                    <li>
                        Materiały udostępniane podczas Konferencji stanowią własność Organizatora lub prelegentów i są chronione prawem autorskim. Mogą zostać udostępnione jedynie za zgodą autora.
                    </li>
                </ol>
            </div>
            <div>
                <p><span class="statuteParagraphHeader">§7. Dane osobowe</span></p>
                <ol>
                    <li>
                        Dane osobowe Uczestników przetwarzane są zgodnie z obowiązującymi przepisami prawa, w szczególności RODO.
                    </li>
                    <li>
                        Szczegółowe informacje dotyczące przetwarzania danych osobowych znajdują się w Polityce Prywatności dostępnej na Stronie internetowej.
                    </li>
                </ol>
            </div>
            <div>
                <p><span class="statuteParagraphHeader">§8. Odpowiedzialność Organizatora</span></p>
                <ol>
                    <li>
                        Organizator nie ponosi odpowiedzialności za rzeczy Uczestników, które mogą zostać zagubione, zniszczone lub skradzione podczas Konferencji.
                    </li>
                    <li>
                        Odpowiedzialność Organizatora ograniczona jest do przypadków przewidzianych przepisami prawa.
                    </li>
                </ol>
            </div>
            <div>
                <p><span class="statuteParagraphHeader">§9. Postanowienia końcowe</span></p>
                <ol>
                    <li>
                        Organizator zastrzega sobie prawo do zmiany niniejszego Regulaminu.
                    </li>
                    <li>
                        Aktualna wersja Regulaminu obowiązuje od dnia jej publikacji na Stronie internetowej.
                    </li>
                    <li>
                        W sprawach nieuregulowanych niniejszym Regulaminem zastosowanie mają przepisy Kodeksu Cywilnego.
                    </li>
                </ol>
            </div>
        </>
    );
}

export default ConferenceStatute;